<template>
	<div id="ct-entreprise">
		<div class="ct-entreprise-title ct-resolution-width">
			<h2>
				<span class="ct-entreprise-text-title">Bienvenue sur le site de la société</span>
			</h2>
			<div class="ct-entreprise-logo">
            <span>
                <img src="../assets/logo.svg" class="ct-entreprise-logo-img" />
            </span>
			</div>
		</div>

		<div class="ct-entreprise-content">
			<div class="ct-resolution-width ct-justify-text">
				<div class="ct-entreprise-text-image">
					<div class="ct-entreprise-text">
						<p><span class="ct-policy-enter">CREA<span class="ct-primary-color">T</span>ISON</span> est une entreprise
							de conception d'espace extérieur.</p>
						<p class="ct-entreprise-liste-titre">Elle réalise tous vos projets personnels tels que :</p>
						<ul class="ct-entreprise-liste">
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								extension d'habitation
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								accés de garage et dépendances
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								cour
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								terrasse
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								portail
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								VRD
							</li>
							<li>
								<i class="material-icons ct-puce">keyboard_arrow_right</i>
								...
							</li>
						</ul>
					</div>
					<img class="ct-entreprise-image" src="../assets/entreprise/accueil.jpg"/>
				</div>
			</div>
			<div class="ct-resolution-width ct-justify-text">
				<p> Bien entourée par un réseau d'artisans sérieux et compétent, <span class="ct-policy-enter">CREA<span
						class="ct-primary-color">T</span>ISON</span> est capable de répondre à toutes vos demandes.</p>

				<p>Fort d'une expérience de 7ans dans le BTP et de 4 ans dans le paysage, Gaultier TISON souhaite vous
					apporter tout son savoir faire technique et de coordination de travaux avec un seul objectif votre <span
							class="ct-policy-enter">SA<span class="ct-primary-color">T</span>ISFAC<span
							class="ct-primary-color">T</span>ION</span>!</p>
				<p>Créée en 2017, <span class="ct-policy-enter">CREA<span class="ct-primary-color">T</span>ISON</span>
					réalise de nombreux projets extérieurs dans la construction neuve et en rénovation.</p>
				<p>Alors bonne visite sur notre site et à bientot</p>
			</div>
		</div>
		<div class="ct-entreprise-cards ct-resolution-width">
			<div class="ct-entreprise-cards-title">
				<h3>Nos prestations</h3>
			</div>
			<div class="ct-entreprise-cards-list">
				<div class="ct-entreprise-cards-card" v-for="element in menus" :key="element.id">
					<ct-card :menu="element"></ct-card>
				</div>
			</div>
		</div>
		<div class="ct-entreprise-content">
			<div class="ct-resolution-width">
				<div class="ct-entreprise-cards-title">
					<h3>Notre zone d'intervention</h3>
				</div>
			</div>
			<div class="ct-entreprise-map ct-resolution-width">
				<img class="ct-entreprise-map-image" src="../assets/entreprise/map.png"/>

					<div class="ct-entreprise-ville">
						<p>Nous intervenons sur la région Hauts-de-France,</p>
                        <ul>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Nord (59)
                        </li>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Pas-de-Calais (62)
                        </li>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Somme (80)
                        </li>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Aisne (02)
                        </li>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Oise (60)
                        </li>
                        </ul>
                        <p>mais également dans les départements </p>
                        <ul>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Ardennes (08)
                        </li>
                        <li>
                            <i class="material-icons ct-puce">keyboard_arrow_right</i>
                            Marne (51)
                        </li>
                        </ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getMenu} from "../actions/generalData";

	export default {
		name: 'CtEntreprise',
		data() {
			return {
				msg: 'Entreprise',
				menus: []
			}
		},
		mounted: function() {
			this.menus = getMenu();
		}
	}
</script>
<style>
	#ct-entreprise {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.ct-entreprise-title {
		text-align: center;
		margin: 40px 0 20px 0;
	}

	.ct-entreprise-logo-img {
		height: 125px;
	}

	.ct-entreprise-content {
		background-color: #4A4A4A;
		padding: 1em 0 1em 0;
		color: white;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.ct-entreprise-content ul li {
		list-style: none;
		display: flex;
	}

	.ct-entreprise-cards {
		display: flex;
		flex-direction: column;
	}

	.ct-entreprise-cards-title {
		display: flex;
		flex-direction: row;
	}

	.ct-entreprise-cards-list {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		margin: 10px 0px 50px 0px;
	}

	.ct-entreprise-cards-card {
		width: 30%;
	}

	.ct-entreprise-text-image {
		display: flex;
		justify-content: space-between;
	}

	.ct-entreprise-image {
		margin: 40px;
		border: 10px solid #FAFAFA;
		border-radius: 2px;
		width: 30%;
		height: 30%;
		transform: rotate(5deg);
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.6);
	}

	.ct-entreprise-map {
		padding: 1em 0 1em 0;
		width: 80%;
		display: flex;
		justify-content: space-around;
	}

	.ct-entreprise-ville {
		/* display: flex; */
	}

	.ct-entreprise-map-image {
		margin: 40px;
		border: 10px solid #FAFAFA;
		border-radius: 2px;
		width: 25%;
		height: 25%;
		transform: rotate(-5deg);
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.6);
	}

	/*!*tablette*!*/
	/*@media screen and (max-width: 1170px ) {
	}
	 */

	/*!*smartphone*!*/
	@media screen and (max-width: 767px ) {
		.ct-entreprise-image,
		.ct-entreprise-liste,
		.ct-entreprise-liste-titre,
		.ct-entreprise-map-image
		{
			display: none;
		}

		.ct-entreprise-logo-img {
			height: 40px;
		}

		.ct-entreprise-title {
			margin: 20px 0 10px 0;
		}

		.ct-entreprise-cards-list {
			flex-direction: column;
			align-items: center;
			margin: 20px 0px 20px 0px;
		}

		.ct-entreprise-cards-card {
			width: 80%;
			margin-bottom: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/CtEntreprise.vue